<template>
    <div class="text-center">
        <div v-if="!fail">
            <h4 class="text-6 mb-4">
                <span v-if="loading">Verifying Your Payment</span>
                <span v-else>
                    Verifying Payment
                </span>
            </h4>

            <p class="my-5">
                <strong>Your transaction will be completed once payment has been verified.</strong>
            </p>

            <div class="form-group">
                <button @click="submit" :class="['btn btn-success btn-block' , loading ? 'btn-loading disabled' : '']">
                    {{ loading ? 'Verifying' : 'Verify' }} Payment
                </button>
            </div>

            <small class="text-muted">Automatically checking payment in {{ countDown }} seconds.</small>
        </div>
        <div v-else>
            <i class="fa fa-exclamation-triangle fa-2x text-danger"></i>

            <h4 class="text-6 mb-4 mt-3">
                Your Payment Failed
            </h4>

            <p class="text-danger mb-5">
                Your payment failed to go through. <br>
                Click "Retry Transaction" below to try again.
            </p>

            <div class="form-group">
                <div class="row">
                    <div class="col-md-6">
                        <button @click="$router.back()" :class="['btn btn-primary btn-block' , loading ? 'btn-loading' : '']">
                            Retry Transaction
                        </button>
                    </div>
                    <div class="col-md-6">
                        <router-link to="/" class="btn btn-outline-primary btn-block shadow-none">Close</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {statusMixin} from "./status-mixin";

export default {
    name: "stripe",
    mixins: [statusMixin],
    data() {
        return {
            loading: false,
            done: false,
            countDown: 5,
            countDownId: null,
            ref: this.$route.query.id
        };
    },
    methods: {
        submit() {
            if (this.loading || this.done) {
                return;
            }

            this.loading = true;
            this.countDown = 0;

            // Check Payment

            window.axios['post'](`${window.location.origin}/stripe/check`, {
                ref: this.ref
            }).then((response) => {

                if (response.data.success) {
                    if (response.data.body.pending) {
                        this.countDown = 30;
                        this.startCountDown();
                        return;
                    }

                    this.done = true;

                    if (response.data.body.type === "App\\Zesa") {
                        window.history.pushState({}, document.title, "/");
                        this.$router.push(`/zesa/complete?id=${this.ref}`);
                    }

                    if (response.data.body.type === "App\\Airtime") {
                        window.history.pushState({}, document.title, "/");
                        this.$router.push(`/airtime/complete?id=${this.ref}`);
                    }

                    if (response.data.body.type === "App\\Bundle") {
                        window.history.pushState({}, document.title, "/");
                        this.$router.push(`/bundles/complete?id=${this.ref}`);
                    }

                    if (response.data.body.type === "App\\Telone") {
                        window.history.pushState({}, document.title, "/");
                        this.$router.push(`/telone/complete?id=${this.ref}`);
                    }

                    if (response.data.body.type === "App\\Zinara") {
                        window.history.pushState({}, document.title, "/");
                        this.$router.push(`/zinara/complete?id=${this.ref}`);
                    }

                    if (response.data.body.type === "App\\BillerPayment") {
                        window.history.pushState({}, document.title, "/");
                        this.$router.push(`/billers/complete?id=${this.ref}`);
                    }

                    if (response.data.body.type === "App\\TicketPurchase") {
                        window.history.pushState({}, document.title, "/");
                        this.$router.push(`/tickets/complete?id=${this.ref}`);
                    }

                    this.dispatchPaymentStatus(true)

                } else {
                    this.fail = true;
                    this.dispatchPaymentStatus(false)
                }

            }).finally(() => {
                this.loading = false;
            });
        },
        startCountDown() {
            if (this.countDownId) clearTimeout(this.countDownId);

            if (this.countDown > 0) {
                this.countDownId = setTimeout(() => {
                    this.countDown -= 1;
                    this.startCountDown();
                }, 1000);
            } else {
                if (!this.loading) this.submit();
            }
        },
    },

    mounted() {
        this.startCountDown();
    }
}
</script>
